import React, { useState, useEffect } from "react";
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
import Moment from "react-moment";

//Redux
import { useSelector, useDispatch } from "react-redux"; //useDispatch
//Serivce
import ItemService from "../../../../services/supplier_appCommonService";

//Components
import Layout from "../../../../Layout/Layout";
import Constants from "../../../../common/SupplierConstants";
import CustomerConstants from "../../../../common/CustomerConstants";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import { useNavigate } from "react-router-dom";

import ShowStatus from "../../../../Components/Modal/supplier_app/Workflow/ShowStatus";
import configFromEnv from "../../../../services/configuration";
import {
  currencyFormat,
  formatDate,
  formatDateTime,
} from "../../../../common/Validations";
import { SearchField } from "../../../../Components/formElements/SearchField";
import CancelModal from "../../../../Components/Modal/supplier_app/common/CancelModal";
// import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import {
  addPurchaseOrder,
  addRfxNr,
  getPurchaseOrderCustomerV2,
  pODeliverConfirmNr,
  quotationListInfo,
} from "../../../../redux/feature/customer_app/customerSlice";
import { addInquiryID } from "../../../../redux/feature/customer_app/preSalesSlice";
import DispatchPurchaseOrderModal from "./DispatchPurchaseOrderModal";
import CommonFilterCustomerV2 from "../Common/CommonFilterCustomerV2";

const CustomerPurchaseOrderListV2 = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  localStorage.setItem("menu", "Project");
  localStorage.setItem("submenu", "Purchase Order");

  let poDocData = useSelector((state) => state?.customer?.purchaseOrder); // User Details from Store
  let poDocDataTable = useSelector(
    (state) => state?.customer?.purchaseOrder?.pagination,
  ); // User Details from Store
  let module = useSelector(
    (state) => state?.common?.data?.purchaseOrder?.PO?.module,
  ); // config Details from Store

  const [data, setData] = useState([]);
  const [getNewPerPage, setNewPerPage] = useState(10);
  const [isCardVisible, setCardVisible] = useState(true);
  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");

  // eslint-disable-next-line no-unused-vars
  const [getPurchaseDocType, setPurchaseDocType] = useState("");

  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");

  // Show Status Modal
  const [modalShowStatus, setModalShowStatus] = useState(false);
  const [sendDataModal /*setSendDataModal*/] = useState("");
  const [modelTitle /*setModelTitle*/] = useState("");
  const [filterShow, setFilterShow] = useState(false);
  const [getFilter, setFilter] = useState({});

  // OnClick on lineItem  Data
  const lineItemShowModal = (itemLevelData) => {
    const normalizedData = Array.isArray(itemLevelData)
      ? itemLevelData
      : itemLevelData
        ? [itemLevelData]
        : [];

    setItemLevelData(normalizedData);
    setItemLevelColumns(lineItemColInfo);
    setModalTitle("Line Item Details");
    setItemLevelModalShow(true);
  };

  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  const detailedPageBuyer = (rfxNr) => {
    dispatch(addRfxNr(rfxNr));
    navigate(CustomerConstants.CUSTOMER_V2_RFQ_DETAIL);
  };
  const detailedPage = (poNumber) => {
    dispatch(addPurchaseOrder(poNumber));
    navigate(CustomerConstants.CUSTOMER_V2_PURCHASE_ORDER_DETAILS);
  };

  const detailedPageQuotation = (quotationNr, qtnVersion) => {
    let obj = {
      quotationNr,
      qtnVersion,
    };
    dispatch(quotationListInfo(obj));
    navigate(CustomerConstants.CUSTOMER_V2_QUOTATION_DETAILS);
  };

  const detailedPageindent = (inquiryID) => {
    dispatch(addInquiryID(inquiryID));
    navigate(CustomerConstants.CUSTOMER_V2_INDENT_DETAILS);
  };
  //on page load
  useEffect(() => {
    getMasterData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const hideModalStatus = () => {
    setModalShowStatus(false);
  };

  const columns = [
    {
      name: "Purchase Nr",
      id:"purchasingDocumentNr",
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPage(row.purchasingDocumentNr)}
        >
          {row.purchasingDocumentNr}{" "}
        </button>
      ),
      width: "150px",
    },
    {
      name: "Purchase Type",
      id:"productType",
      selector: (row) => row.productType || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.productType} </p>
        </div>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Line Items",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemShowModal(row.items)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          {/* <span className="suppliersIcon"> {row.items?.length} </span> */}
          <span className="suppliersIcon">
            {Array.isArray(row.items) ? row.items.length : row.items ? 1 : 0}
          </span>
        </>
      ),
      width: "120px",
    },
    /* {
      name: "Status",
      cell: (row) => (
        <>
          <TableStatusField status={row.rfxHeaderStatus} />
        </>
      ),
      selector: (row) => row.rfxHeaderStatus || "--",
      sortable: true,
      width: "120px",
    }, */
    {
      name: "Good Receive",
      // id: "invoiceNr",
      cell: (row) => (
        <button className="btnTable" onClick={() => showDispatchInvoice(row)}>
          Confirm
        </button>
      ),

      width: "150px",
    },
    {
      name: "Date",
      id:"purchasingDocumentDate",
      selector: (row) => formatDate(row?.purchasingDocumentDate) || "--",
      sortable: true,
      width: "130px",
    },
    {
      name: "Purchase Value",
      cell: (row) => (
        <div>
          <p className="numberFormate m-0 p-0 pt-1 fw-bold">
            {currencyFormat(Number(row.qtnTotal).toFixed(2))}
          </p>
          <p className="m-0 p-0 pt-1 fw-bold">{row.currency}</p>
        </div>
      ),
      selector: (row) => row.qtnTotal || "--",
      sortable: true,
      width: "120px",
    },
    // {
    //   name: "Currency ",
    //   cell: (row) => (
    //     <>
    //       <span className="m-0 p-0 pt-1 fw-bold">{row.currency}</span>
    //     </>
    //   ),
    //   selector: (row) => row.currency || "--",
    //   sortable: true,
    //   width: "110px",
    // },
    {
      name: "Supplier",
      id:"organisationName",
      selector: (row) => row.AssociateNumber,
      sortable: true,
      width: "110px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.AssociateNumber} </p>
          <p className="m-0 p-0">{row.organisationName} </p>
        </div>
      ),
    },
    {
      name: "Payment Terms",
      selector: (row) => row.paymentTermsCode,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.paymentTerms} </p>
        </div>
      ),
    },
    {
      name: "Created Date",
      selector: (row) => formatDateTime(row.createdAt),
      cell: (row) => (
        <Moment format={configFromEnv.TIME_FORMATE_WITH_TIME}>
          {row.createdAt}
        </Moment>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Company",
      id:"companyCodeDesc",
      cell: (row) => (
        <>
          <span> {row.companyCodeDesc} </span>
        </>
      ),
      width: "150px",
    },
    // {
    //   name: "Indent Number",
    //   selector: (row) => row.item?.inquiryNr || "--",
    //   sortable: true,
    //   width: "150px",
    // },
    {
      name: "Indent Nr",
      selector: (row) => row.inquiryNr || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPageindent(row.inquiryNr)}
        >
          {row.inquiryNr || "-"}{" "}
        </button>
      ),
      width: "140px",
    },
    {
      name: "RFQ",
      id:"rfxNr",
      selector: (row) => row.rfxNr,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPageBuyer(row.rfxNr)}
        >
          {row.rfxNr}{" "}
        </button>
      ),
      width: "160px",
    },
    {
      name: "Quotation Nr",
      id:"quotationNr",
      selector: (row) => row.quotationNr || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPageQuotation(row.quotationNr)}
        >
          {row.quotationNr || "-"}{" "}
        </button>
      ),
      width: "150px",
    },
  ];
  const lineItemColInfo = [
    {
      name: "Material/Service",

      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.materialCode} </p>
          <p className="m-0 p-0">{row.materialDescription} </p>
        </div>
      ),
      width: "180px",
    },
    {
      name: "Material Group",
      cell: (row) => <span>{row.materialGroup} </span>,
      width: "220px",
    },
    {
      name: "Quantity",
      cell: (row) => <span>{row.indentQuantity} </span>,
      width: "220px",
    },
    {
      name: "UOM",
      cell: (row) => <span>{row.orderUnitOfMeasure} </span>,
      width: "220px",
    },
    {
      name: "Delivery Date",
      cell: (row) => <span>{formatDate(row?.deliveryDate)}</span>,
      width: "220px",
    },
  ];

  const getMasterData = async () => {
    let obj = {
      codeType: "PurchaseDocType",
    };
    await ItemService.getMasterData(obj).then((item) => {
      if (item?.status === 200) {
        setPurchaseDocType(item?.data);
      } else {
        setPurchaseDocType([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
  };

  const loadInitialPoData = async () => {
    setData(poDocData?.data);
  };

  const handlePageChange = (page) => {
    let obj = {
      ueryName: "GET_PO_LIST",
      module: "PO",
      page: page,
      per_page: getNewPerPage,
      rowFilter: {
        $and: [getFilter],
      },
    };

    dispatch(getPurchaseOrderCustomerV2(obj));
    setData(poDocData?.data);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "GET_PO_LIST",
      module: "PO",
      page: page,
      per_page: newPerPage,
      rowFilter: {
        $and: [getFilter],
      },
    };
    setNewPerPage(newPerPage);
    dispatch(getPurchaseOrderCustomerV2(obj));
    setData(poDocData?.data);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "GET_PO_LIST",
      module: "PO",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getPurchaseOrderCustomerV2(obj));
  };

  //on page load
  useEffect(() => {
    let obj = {
      queryName: "GET_PO_LIST",
      module: "PO",
      page: 1,
      per_page: 10,
    };
    dispatch(getPurchaseOrderCustomerV2(obj));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    loadInitialPoData(); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [poDocData]);

  /* Cancel Modal */
  const [getCancelModalStatus, setCancelModalStatus] = useState(false);
  // const cancelModalShow = () => {
  //   setCancelModalStatus(true);
  // };
  const cancelModalHide = () => {
    setCancelModalStatus(false);
  };

  /* Handle selected rows */
  const [getSelectedRows, setSelectedRows] = useState([]);

  const handleRowSelected = ({ selectedRows }) => {
    const validRows = selectedRows.filter(
      (item) => item?.statusHeader !== "Cancelled",
    );
    setSelectedRows(validRows);
  };

  //invoice
  const [getModalEditDispatch, setModalEditDispatch] = useState(false);
  const [invoiceData, setInvoiceData] = useState(null);
  const showDispatchInvoice = (rowData) => {
    dispatch(pODeliverConfirmNr(""));

    setModalEditDispatch(true);
    setInvoiceData(rowData);
  };
  const hideInvoiceModal = () => {
    setModalEditDispatch(false);
    // setEwayBillData(null);
  };

  const handleAdvanceSearchFuncApi = async (filters) => {
    let obj = {
      queryName: "GET_PO_LIST",
      module: "PO",
      page: 1,
      per_page: 10,
      searchTerm: "",
      rowFilter: {
        $and: [filters],
      },
    };
    setFilter(filters);
    dispatch(getPurchaseOrderCustomerV2(obj));
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={8} lg={8}>
                <h2 className="mainTitle">Purchase Order List</h2>
                <p className="subText">Purchase list and details</p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
              <Col xs={4} md={1} lg={1}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i class="bi bi-filter"></i>
                </span>
              </Col>
            </Row>

            <hr />
            <Row>
              <Col xs={12} md={12} lg={12}>
                {filterShow && (
                  <CommonFilterCustomerV2
                    getfiltereddata={columns}
                    cancelAction={() => setFilterShow(!filterShow)}
                    onSubmit={(filters) => {
                      // console.log(">>Received filters from child:", filters);
                      // const filterData=[filters]
                      handleAdvanceSearchFuncApi(filters);
                      // You can now use the filters here
                    }}
                  />
                )}
              </Col>
            </Row>

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">PL</span>
                    </Col>
                    <Col xs={6} md={4} lg={4}>
                      <span className="headerTitle">Purchase Order List</span>
                      <span className="subHeaderTitle">
                        View of Purchase Order and Status{" "}
                      </span>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          data={data}
                          progressPending={poDocData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={poDocDataTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          onSelectedRowsChange={handleRowSelected}
                          // selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />

      <ShowStatus
        show={modalShowStatus}
        onHide={() => hideModalStatus()}
        rowdatamodal={sendDataModal}
        modeltitle={modelTitle}
      />
      <CancelModal
        title="Cancel the Purchase Order"
        type={module}
        show={getCancelModalStatus}
        onHide={cancelModalHide}
        selectedrow={getSelectedRows}
      />
      <DispatchPurchaseOrderModal
        show={getModalEditDispatch}
        onHide={() => hideInvoiceModal()}
        invoiceinfo={invoiceData}
        // onsuccessdata={handleSuccessData}
        // viewInvoiceData={viewInvoiceData}
      />
    </main>
  );
};

export default CustomerPurchaseOrderListV2;
